import { exp } from "./export";
import { lang } from '../lang.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';
import { palette } from '../palette.js';

exp.getMedallionWordChart = () => {
    let result = [];

    let myRows = [];
    let counter = 0;
    for (let i = 0; i < settings.rows; i++) {
        let nextRow = [];
        let rowLength = (i == 0) ? 1 : i * 8;
        for (let j = 0; j < rowLength; j++) {
            let bead = beads.arr[counter];
            if (!bead.ignore) {
                let mySwatch = b3.store.state.swatches.find(element => element.id == bead.style);
                if (mySwatch === undefined) {
                    mySwatch = {
                        letterCode: '',
                    };
                }
                nextRow.push({
                    letterCode: mySwatch.letterCode
                });
            }
            counter++;
        }
        myRows.push(nextRow);
    }
    let thisRow;
    myRows.forEach((row, i) => {
        let rowNumber = i + 1;
        result.push(lang.caps(lang.get('row')) + ' ' + rowNumber.toString() + ': ');

        thisRow = exp.parseRow(row);
        thisRow.push('\n');

        thisRow.forEach(element => {
            result.push(element);
        });
    });

    return [
        {
            text: 'Word Chart',
            style: 'header'
        },
        {
            text: {text: result},
            style: 'wordChart'
        }
    ];
};